/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import CheckIcon from '@offerzen/zenicon/CheckIcon'
import AccessibleIcon from '../AccessibleIcon'
import FormErrorMessage from '../FormErrorMessage'
import styles, { iconTheme, inputTheme } from './styles'

const Checkbox = ({ id, label, checked, meta, input, className, onChange, ...props }) => {
  const checkedBox = input.value || checked
  const handler = input.onChange || onChange
  const errored = meta.touched && meta.error
  const theme = errored ? 'error' : props.theme

  return (
    <>
      <div className={cx(styles.wrapper, className)}>
        <span className={cx(styles.checkbox, props.disabled && styles.disabledCheckbox)}>
          <input
            id={id}
            type="checkbox"
            className={cx(styles.input, inputTheme(theme))}
            {...input}
            onChange={handler}
            value={undefined}
            checked={checkedBox}
            {...props}
          />
          {Boolean(checkedBox) && (
            <div className={styles.icon}>
              <AccessibleIcon icon={CheckIcon} size={18} color={iconTheme(theme)} />
            </div>
          )}
        </span>
        {Boolean(label) && (
          <label htmlFor={id} className={cx(styles.label, props.disabled && styles.labelDisabled)}>
            {label}
          </label>
        )}
      </div>
      {Boolean(errored) && <FormErrorMessage text={meta.error} />}
    </>
  )
}

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.string,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'dark', 'tertiary', 'info']),
  className: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    onChange: PropTypes.func,
  }),
  disabled: PropTypes.bool,
}

Checkbox.defaultProps = {
  meta: {},
  input: {},
  theme: 'primary',
  checked: false,
}

export default Checkbox
